import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';

export const LEQ_auto_limit_enhance_API_CALL = createAsyncThunk(
  'LEQ_auto_limit_enhance_API_CALL',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    dispatch({ type: 'LEQ_auto_limit_enhance_API_CALL/pending', payload: {} });
    const {
      auto_limit_enhanceAPIPayload,
      successFn = () => {},
      errorFn = () => {},
      finallyFn,
    } = payload;
    const { customerId, Authorization, customerRefNum } =
      auto_limit_enhanceAPIPayload;
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'customerkyc/autolimitenhanceconsent',
      headers: {
        Authorization,
      },
      payload: {
        customerRefNum,
      },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const limit_enhanceRes = res;
        dispatch({
          type: 'LEQ_auto_limit_enhance_API_CALL/fulfilled',
          payload: limit_enhanceRes,
        });
        if (successFn) successFn(limit_enhanceRes);
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({
          type: 'LEQ_auto_limit_enhance_API_CALL/rejected',
          payload: err,
        });
        if (errorFn) errorFn(err);
      },
      finallyFn,
    });
  }
);

export const LEQ_auto_limit_enhance_API_CALL_extrareducer = {
  [LEQ_auto_limit_enhance_API_CALL.pending]: (state, action) => {
    state.auto_limit_enhanceAPICall.isLoading = true;
  },
  [LEQ_auto_limit_enhance_API_CALL.fulfilled]: (state, action) => {
    state.auto_limit_enhanceAPICall.isLoading = false;
    state.auto_limit_enhanceAPICall.isSuccess = true;
    state.auto_limit_enhanceAPICall.isError = false;
    state.auto_limit_enhanceAPICall.response = action.payload;
  },
  [LEQ_auto_limit_enhance_API_CALL.rejected]: (state, action) => {
    state.auto_limit_enhanceAPICall.isLoading = false;
    state.auto_limit_enhanceAPICall.isSuccess = false;
    state.auto_limit_enhanceAPICall.isError = true;
    state.auto_limit_enhanceAPICall.response = action.payload;
  },
};
